import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';

import { blur } from '@/theme/constants';

interface CountCardProps {
  label: string;
  count?: number;
  isLoading?: boolean;
}
const CountCard = ({ label, count = 0, isLoading = false }: CountCardProps) => (
  <Paper
    className="CountCard-root"
    component="dl"
    elevation={3}
    sx={{
      position: 'relative',
      bgcolor: 'background.default',
      textAlign: 'start',
      flex: 1,
      m: 0,
      p: 1
    }}
  >
    {isLoading && (
      <Stack
        sx={{
          backdropFilter: blur.default,
          position: 'absolute',
          insetBlock: 0,
          insetInline: 0,
          zIndex: 1,
          bgcolor: 'transparent',
          '.MuiTableBody-root &:hover': {
            bgcolor: 'transparent'
          }
        }}
      />
    )}
    <Typography component="dt" variant="body2" mb={1} sx={{ color: 'grey.800' }}>
      {label}
    </Typography>
    <Typography component="dd" variant="h3" sx={{ color: 'primary.main' }}>
      {count}
    </Typography>
  </Paper>
);

export default CountCard;
